const handleCollapse = ($container = $('.js-collapse')) => {
  $container.each(function() {
    const $collapseContainer = $(this);
    const $contentContainer = $collapseContainer.find('.js-collapse-container');
    const $trigger = $collapseContainer.find('.js-collapse-trigger');
    const maxRows = parseInt($collapseContainer.data('max-rows'));
    const lineHeight = parseInt($contentContainer.css('line-height'));
    const originalHeight = $contentContainer.outerHeight();
    const maxHeight = maxRows * lineHeight;
    const currentHeight = $collapseContainer.hasClass('is-open') ? originalHeight : maxHeight;

    if ($collapseContainer.hasClass('collapse-initialized')) {
      return;
    }

    if (maxHeight >= originalHeight) {
      $trigger.remove();

      return;
    }

    $collapseContainer.addClass('collapse-initialized');

    $contentContainer.attr('data-original-height', originalHeight).attr('data-max-height', maxHeight).css({
      'max-height': currentHeight,
      'transition': 'max-height .4s',
      'overflow': 'hidden'
    });
  });
}

$(document).on('click', '.js-collapse-trigger', function(event) {
  const $this = $(this);
  const $collapseContainer = $this.closest('.js-collapse');
  const $targetCollapseContainer = $(`[data-id="${$collapseContainer.data('id')}"]`);

  $targetCollapseContainer.each(function() {
    const $this = $(this);
    const $contentContainer = $this.find('.js-collapse-container');
    const $target = $this.find('.js-collapse-trigger');
    const readMore = $target.data('content-more') || 'Read More';
    const readLess = $target.data('content-less') || 'Read Less';
    const maxHeight = parseInt($contentContainer.data('max-height'));

    if ($this.hasClass('is-open')) {
      $contentContainer.css('max-height', maxHeight);

      $this.removeClass('is-open');

      $target.text(readMore);
    } else {
      $contentContainer.css('max-height', $contentContainer.data('original-height'));

      $this.addClass('is-open');

      $target.text(readLess);
    }
  });

  event.preventDefault();
});

export default handleCollapse;

$('.js-collapse').each(function() {
  const $this = $(this);

  if ($this.closest('.js-slider').length > 0) {
    return;
  }

  handleCollapse($this);
});
